/**
 * @typedef {import('../types.js').OmitHandle} OmitHandle
 */
var own = {}.hasOwnProperty;
/**
 * Factory to check if a given node can have a tag omitted.
 *
 * @param {Object.<string, OmitHandle>} handlers
 * @returns {OmitHandle}
 */

export function omission(handlers) {
  return omit;
  /**
   * Check if a given node can have a tag omitted.
   *
   * @type {OmitHandle}
   */

  function omit(node, index, parent) {
    return own.call(handlers, node.tagName) && handlers[node.tagName](node, index, parent);
  }
}